import React, { memo } from 'react';

import { ImageType } from '../../types/ImageType';
import { SharedButtonProps } from '../../types/SharedButtonProps';
import { Box } from '../Box/Box';
import { Button } from '../Button/Button';
import { Image } from '../Image/Image';
import { Layout } from '../Layout/Layout';
import { Text } from '../Text/Text';
import { PresetKey } from './types';
import { usePreset } from './usePreset';

interface Props {
  /** Error page preset */
  preset: PresetKey;
  /** Required CTA action for resolving the error state */
  resolveAction?: SharedButtonProps;
  /** Override preset */
  description?: string;
  image?: ImageType;
  imageAlt?: string;
  resolveActionText?: string;
  title?: string;
}

export const ErrorPage = memo((props: Props) => {
  const { description, image, imageAlt, resolveActionText, title } = usePreset(
    props.preset,
  );
  const resolveAction = props.resolveAction;

  return (
    <Layout
      align="center"
      direction="column"
      h="100%"
      justify="center"
      minW="min-content"
      p={12}
      spacing={4}
      w="100%"
    >
      <Image alt={imageAlt} image={image} />
      <Text textAlign="center" variant="title">
        {title}
      </Text>
      <Text color="text.secondary" textAlign="center">
        {description}
      </Text>
      {resolveAction && (
        <Box pt={8}>
          <Button
            {...resolveAction}
            text={resolveActionText || resolveAction.text}
            variant="primary"
          />
        </Box>
      )}
    </Layout>
  );
});
